module.exports = __webpack_public_path__ + "static/img/banner_05.723cae23.png";